var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.86H17.24C16.44 18.86 15.68 19.17 15.12 19.73L13.41 21.42C12.63 22.19 11.36 22.19 10.58 21.42L8.87 19.73C8.31 19.17 7.54 18.86 6.75 18.86H6C4.34 18.86 3 17.53 3 15.89V4.98001C3 3.34001 4.34 2.01001 6 2.01001H18C19.66 2.01001 21 3.34001 21 4.98001V15.89C21 17.52 19.66 18.86 18 18.86Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.6601C16 13.8601 14.21 12.4001 12 12.4001C9.79 12.4001 8 13.8601 8 15.6601M12 10.0001C12.306 10.0001 12.609 9.93982 12.8917 9.82273C13.1743 9.70563 13.4312 9.53401 13.6476 9.31765C13.8639 9.10129 14.0355 8.84443 14.1526 8.56174C14.2697 8.27905 14.33 7.97607 14.33 7.67009C14.33 7.36411 14.2697 7.06112 14.1526 6.77844C14.0355 6.49575 13.8639 6.23889 13.6476 6.02253C13.4312 5.80617 13.1743 5.63454 12.8917 5.51745C12.609 5.40035 12.306 5.34009 12 5.34009C11.382 5.34009 10.7894 5.58557 10.3524 6.02253C9.91548 6.45949 9.67 7.05213 9.67 7.67009C9.67 8.28804 9.91548 8.88069 10.3524 9.31765C10.7894 9.75461 11.382 10.0001 12 10.0001Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsManager);
export default __webpack_public_path__ + "static/media/forms_manager.429f34b64083f0491b2f61e0bcffd9f4.svg";
export { ForwardRef as ReactComponent };